var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { colors, getFontSize } from '../../abstracts';
export var TabsElement = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  max-width: ", ";\n  overflow-x: auto;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  max-width: ", ";\n  overflow-x: auto;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? "".concat(maxWidth, "px") : 'unset');
});
var getTabElementPadding = function (variant, iconSide) {
    if (variant === 'regular') {
        return iconSide === 'center' ? '6px 8px' : '12px';
    }
    else {
        return iconSide === 'center' ? '3px 6px' : '4px 6px';
    }
};
export var TabElement = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  margin: 0;\n  padding: ", ";\n  color: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  margin: 0;\n  padding: ", ";\n  color: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var iconSide = _a.iconSide;
    return iconSide === 'center' ? 'column' : 'row';
}, function (_a) {
    var variant = _a.variant, iconSide = _a.iconSide;
    return getTabElementPadding(variant, iconSide);
}, function (_a) {
    var color = _a.color;
    return color;
}, colors.white, function (_a) {
    var isActive = _a.isActive, color = _a.color;
    return "inset 0 -4px 0 ".concat(isActive ? color : colors.neutralBrightest);
}, function (_a) {
    var isActive = _a.isActive;
    return !isActive && colors.neutralBrightest;
}, function (_a) {
    var isActive = _a.isActive;
    return "inset 0 -4px 0 ".concat(!isActive && colors.neutralBrighter);
}, function (_a) {
    var isActive = _a.isActive;
    return !isActive && colors.neutralBrighter;
}, function (_a) {
    var isActive = _a.isActive;
    return "inset 0 -4px 0 ".concat(!isActive && colors.neutralBright);
});
export var TitleElement = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  line-height: 1.3;\n  font-size: ", ";\n"], ["\n  display: inline-block;\n  line-height: 1.3;\n  font-size: ", ";\n"])), function (_a) {
    var iconSide = _a.iconSide;
    return getFontSize(iconSide === 'center' ? 1 : 2);
});
var getIconWrapperPadding = function (variant, iconSide) {
    var left = '0px', right = '0px', bottom = '0px';
    if (iconSide === 'right') {
        left = variant === 'regular' ? '4px' : '5px';
    }
    else if (iconSide === 'left') {
        right = variant === 'regular' ? '4px' : '5px';
    }
    else {
        bottom = '2px';
    }
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n  "], ["\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-bottom: ", ";\n  "])), left, right, bottom);
};
export var IconWrapper = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n"])), function (_a) {
    var variant = _a.variant, side = _a.side;
    return getIconWrapperPadding(variant, side);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
